import { selectEntitiesCompetitorsEntityPosition } from '../../../../selectors/entities/competitors/entitiesCompetitorsPrimary.selector';
import { selectEntitiesMatchesEntityStatus } from '../../../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { type StateType } from '../../../../states';
import { MatchEntityStatus } from '../../../../states/entities/matches';
import { Selector } from '../../../../types/selectors';
import { createResultEqualSelector } from '../../../../utils/reselect';
import { type LineUpRacerSelectorProps } from '../LineUpRacer/LineUpRacer.selector';
import { selectLineUpCompetitor } from '../LineUpRacer/LineUpRacer.selector';

type LineUpRacerInformationPropsType = {
  content?: string;
  isOut: boolean;
  isMatchEnded: boolean;
};

const selectLineUpRacerGapToLeader: Selector<string | undefined> = (
  state: StateType,
  props: LineUpRacerSelectorProps = {},
) => selectLineUpCompetitor(state, props)?.gapToLeader;

const selectLineUpRacerRetired: Selector<boolean> = (state: StateType, props: LineUpRacerSelectorProps = {}) =>
  selectLineUpCompetitor(state, props)?.retired ?? false;

const selectLineUpRacerInformationProps: Selector<LineUpRacerInformationPropsType> = createResultEqualSelector(
  [
    selectEntitiesCompetitorsEntityPosition,
    selectLineUpRacerGapToLeader,
    selectLineUpRacerRetired,
    selectEntitiesMatchesEntityStatus,
  ],
  (position, gapToLeader, retired, matchStatus) => ({
    content: !MatchEntityStatus.isPrematch(matchStatus) && position === 1 ? undefined : gapToLeader,
    isOut: retired,
    isMatchEnded: MatchEntityStatus.isEnded(matchStatus),
  }),
);

export default selectLineUpRacerInformationProps;
